class SingleSelectGroup {
    constructor(container) {
        this.container = container;

        this.checkboxes = Array.from(
            this.container.querySelectorAll('input[type="checkbox"]'),
        );

        if (this.checkboxes.length === 0) {
            throw new Error("No checkboxes found in the container");
        }

        this._bindEvents();
    }

    _bindEvents() {
        this.checkboxes.forEach((checkbox) => {
            checkbox.addEventListener("change", (event) => {
                if (event.target.checked) {
                    this._uncheckOthers(event.target);
                }
            });
        });
    }

    _uncheckOthers(selectedCheckbox) {
        this.checkboxes.forEach((checkbox) => {
            if (checkbox !== selectedCheckbox) {
                checkbox.checked = false;
            }
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const singleSelectGroups = document.querySelectorAll(
        `[data-single-select-group]`,
    );

    singleSelectGroups.forEach((element) => {
        new SingleSelectGroup(element);
    });
});
